import React from 'react';
import { Box, Typography, styled } from '@mui/material';

import Navigation from './navigation';
import Footer from './footer';
import SocialMedia from 'components/social-media';
import { emailAddress } from 'utils/data';

const Layout = ({ children }) => (
  <>
    <Navigation />

    <main>
      {children}
      <FloatingBox>
        <SocialMedia orientation='vertical' />
      </FloatingBox>

      <FloatingBox sx={{ right: '-5.5rem' }}>
        <FloatingEmail>
          <FloatingEmailText variant='subtitle2'>
            <a href={`mailto:${emailAddress}`}>{emailAddress}</a>
          </FloatingEmailText>
        </FloatingEmail>
      </FloatingBox>
    </main>

    <Footer />
  </>
);

export default Layout;

const FloatingBox = styled(Box)(({ theme }) => ({
  position: 'fixed',
  bottom: 0,
  zIndex: theme.zIndex.fab,
  padding: theme.spacing(0, 5),

  '&::after': {
    content: '""',
    display: 'block',
    margin: '0 auto',
    height: '6rem',
    width: '2px',
    borderRadius: theme.borderRadius.small,
    backgroundColor: theme.palette.slate.main,
  },

  [theme.breakpoints.down('lg')]: {
    display: 'none',
  },
}));

const FloatingEmail = styled('div')(({ theme }) => ({
  transform: 'rotate(90deg) translateX(-50%) translateY(-5%)',
}));

const FloatingEmailText = styled(Typography)(({ theme }) => ({
  color: theme.palette.slate.light,
  letterSpacing: '2px',
  transition: 'color .3s',

  '&:hover': {
    color: theme.palette.secondary.main,
  },
}));
